<template>
  <div class="fullPage">
    <div class="fullPage-body">
      <div class="nav">
        <div class="nav-block blockFirst">
          <img src="../../assets/img/already.png" class="firstImg" />
          移动端查看数据
        </div>
        <div class="blockSecond">禹州苏皖区车位营销数据</div>
        <img src="../../assets/img/lineback.png" alt="" class="backLine" />
        <div class="nav-block blockThird">
          <img
            src="../../assets/img/logos.png"
            style="
              width: 24px;
              height: 24px;
              margin-right: -30px;
              z-index: 10;
              position: relative;
              z-index: 10;
              left: 4%;
              top: -4%;
            "
            alt=""
          />
          <!-- <el-date-picker
            v-model="value1"
            type="datetimerange"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%; height: 100%"
            format="yyyy-MM-dd"
          >
          </el-date-picker> -->
        </div>
      </div>
      <div class="borderBox"></div>

      <div class="nav-bottom-text">
        <div class="nav-text">
          <div class="nav-text-item nav-item-first" @click="areaClick">
            <div class="navListItem">
              苏皖区域
              <img
                src="../../assets/img/bttonm.png"
                style="width: 15px; height: 15px; margin-left: 5px"
              />
            </div>
            <div class="navList" v-if="areaIf">
              <div
                class="nav-list-item"
                v-for="(item, index) in areaData"
                :key="index"
                @click="areaDataClick(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="nav-text-item nav-item-first" @click="allprojectClick">
            <div class="navListItem">
              全部项目
              <img
                src="../../assets/img/bttonm.png"
                style="width: 15px; height: 15px; margin-left: 5px"
              />
            </div>
            <div class="navList" v-if="projectIf">
              <div
                class="nav-list-item"
                v-for="(item, index) in projectData"
                :key="index"
                @click="projectClick(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="nav-text-item">15825个车位</div>
          <div class="nav-text-item">19781户</div>
          <div class="nav-text-item">车位配比1.25</div>
        </div>
      </div>

      <!-- 车位数据总览 -->
      <div class="carData">
        <div class="carList">
          <div class="carData-text">车位数据总览</div>
          <div class="car-day-data">
            <div
              @click="prevWeek"
              style="color: #1eb6ff; border-radius: 15px 0 0 15px"
              class="dateBtn"
            >
              ◀
            </div>
            <el-date-picker
              v-model="chooseDate"
              type="date"
              placeholder="选择日期"
              :format="dateFormat"
              value-format="yyyy-MM-dd"
              @change="chooseDates"
              style="width: 100px; height: 30px"
              :clearable="false"
            >
            </el-date-picker>
            <div
              @click="nextDay"
              style="color: #1eb6ff; border-radius: 0 15px 15px 0"
              class="dateBtn"
            >
              ▶
            </div>
          </div>
        </div>
        <!-- 数据模块 -->
        <div class="car-data-block">
          <div class="car-data-block-item">
            <span class="car-item-one"
              >13 <span class="car-item-span">个</span></span
            >
            <span class="item-text">项目数量</span>
          </div>
          <div class="car-data-block-item">
            <span class="car-item-two"
              >8228 <span class="car-item-span">个</span></span
            >
            <span class="item-text">已售车位</span>
          </div>
          <div class="car-data-block-item">
            <span class="car-item-third"
              >7713 <span class="car-item-span">个</span></span
            >
            <span class="item-text">在售车位</span>
          </div>
          <div class="car-data-block-item">
            <span class="car-item-four"
              >3.13<span class="car-item-span"> 亿元</span></span
            >
            <span class="item-text">在售货值</span>
          </div>
          <div class="car-data-block-item">
            <span class="car-item-five">55%</span>
            <span class="item-text">车位去化率</span>
          </div>
        </div>
      </div>

      <!-- 实时销售数据 -->
      <div class="carData">
        <div class="carData-text">
          实时销售数据
          <div class="nowFollwdata">
            <div class="nowFollwCir"></div>
            <div class="nowFollowText">数据时间 2021-10-19 18:00</div>
          </div>
        </div>
        <!-- 数据模块 -->
        <div class="car-data-block">
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">带看客户</div>
            <div class="sell-item-one">
              954
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              11.54
              <span class="car-item-span">万</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 实时跟进数据 -->
      <div class="seller-data">
        <div class="sellerdata-text">
          实时跟进数据
          <div class="nowFollwdata">
            <div class="nowFollwCir"></div>
            <div class="nowFollowText">数据时间 2021-10-19 18:00</div>
          </div>
        </div>
      </div>
      <!-- 图形 -->
      <div class="echartsBody">
        <img src="../../assets/img/blueback.png" alt="" class="blueBack" />
        <div class="echarts_1">
          <div
            id="myChartNowfollow"
            :style="{
              width: '100%',
              height: '62vh',
              marginTop: '30px',
              borderRadius: '10px',
            }"
          />
          <div class="echartsIndi">
            <div class="echarts-list">
              <div class="devColor1"></div>
              <span class="devColortext1">前天</span>
            </div>
            <div class="echarts-list">
              <div class="devColor1"></div>
              <span class="devColortext1">今天</span>
            </div>
            <div class="echarts-list">
              <div class="devColor1"></div>
              <span class="devColortext1">昨天</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 昨日销售数据 -->
      <div class="carData">
        <div class="carData-text">
          昨日销售数据
          <div class="car-day-data leftDistance">
            <div
              @click="prevWeek"
              style="color: #1eb6ff; border-radius: 15px 0 0 15px"
              class="dateBtn"
            >
              ◀
            </div>
            <el-date-picker
              v-model="chooseDate"
              type="date"
              placeholder="选择日期"
              :format="dateFormat"
              value-format="yyyy-MM-dd"
              @change="chooseDates"
              style="width: 100px; height: 30px"
              :clearable="false"
            >
            </el-date-picker>
            <div
              @click="nextDay"
              style="color: #1eb6ff; border-radius: 0 15px 15px 0"
              class="dateBtn"
            >
              ▶
            </div>
          </div>
        </div>
        <!-- 数据模块 -->
        <div class="car-data-block">
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">带看客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
          <div class="sell-data-block-item">
            <img
              src="../../assets/img/borderLine.png"
              alt=""
              class="boderLine"
            />
            <div class="sellitem-title">跟进客户</div>
            <div class="sell-item-one">
              313
              <span class="car-item-span">户</span>
            </div>
            <div class="rightselDdata">
              较昨日
              <span class="colorData">+10%</span>
            </div>
            <div class="rightselDdata">
              七日前
              <span class="colorData">+10%</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 销售趋势 -->
      <div class="seller-data">
        <div class="sellerdata-text">
          销售趋势
          <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
        </div>
        <div class="sellerdata-btn">
          <div class="chartsbtn-item">跟进阶段</div>
          <div class="chartsbtn-item">跟进户数</div>
          <div class="chartsbtn-item">签约金额</div>
        </div>
      </div>
      <!-- 图形 -->
      <div class="echartsBody">
        <img src="../../assets/img/blueback.png" alt="" class="blueBack" />
        <div class="echarts_1">
          <div
            id="myChart"
            :style="{
              width: '100%',
              height: '62vh',
              marginTop: '30px',
              borderRadius: '10px',
            }"
          />
          <div class="echartsIndi">
            <div class="echarts-list">
              <div class="devColor1"></div>
              <span class="devColortext1">前天</span>
            </div>
            <div class="echarts-list">
              <div class="devColor1"></div>
              <span class="devColortext1">今天</span>
            </div>
            <div class="echarts-list">
              <div class="devColor1"></div>
              <span class="devColortext1">昨天</span>
            </div>
          </div>
        </div>
      </div>
      <div class="coloumtitleText">
        <div class="leftColumTit">
          <div class="leftColumText">
            项目营销成果
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
        <div class="rightColumTit">
          <div class="rightColumText">
            项目营销强度
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
      </div>
      <!-- 柱形图 -->
      <div class="columnChart">
        <sellResult></sellResult>
      </div>
      <div class="coloumtitleText">
        <div class="leftColumTit">
          <div class="leftColumText">
            项目业主覆盖率
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
        <div class="rightColumTit">
          <div class="rightColumText">
            项目业主链接率
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
      </div>

      <div class="columnChart">
        <showOwner />
      </div>
      <div class="coloumtitleText">
        <div class="leftColumTit">
          <div class="leftColumText">
            签约车位分布
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
        <div class="rightColumTit">
          <div class="rightColumText">
            客户转化漏斗
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
      </div>
      <!-- 柱形图3 4 -->
      <div class="columnChart">
        <pieShow />
      </div>
      <div class="coloumtitleText">
        <div class="leftColumTit">
          <div class="leftColumText">
            <span style="overflow: inherit; white-space: nowrap"
              >置业顾问工作效率</span
            >
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
        <div class="rightColumTit">
          <div class="rightColumText">
            <span style="overflow: inherit; white-space: nowrap">
              置业顾问工作强度
            </span>
            <timeChange :timeData="timeData" @dayTimeData="getDayTime" />
          </div>
        </div>
      </div>
      <div class="columnChart">
        <ownerCount />
      </div>
    </div>
  </div>
</template>
  <script>
import html2canvas from "html2canvas";
import columCahrts3 from "../../components/columnCharts3";
import timeChange from "../../components/timeChange";
import ownerCount from "../../components/ownerCount";
import showOwner from "../../components/showOwner";
import pieShow from "../../components/pieShow";
import sellResult from "../../components/sellResult";
export default {
  components: {
    charts3: columCahrts3,
    timeChange: timeChange,
    ownerCount,
    showOwner,
    pieShow,
    sellResult,
  },
  data() {
    return {
      // 项目判断
      projectIf: false,
      // 传给时间选择组件
      timeDatas: {
        typeTimeC: 2,
      },
      timeData: {
        typeTimeC: 1,
      },
      mouthText: "近12个月",
      mouthRange: 12,
      nearType: false,
      // 日期格式
      dateFormat: "MM / dd",
      // 月份格式
      mouthFormat: "yyyy-MM",
      // 选择月份
      chooseMouth: "",
      // 选择日期
      chooseDate: "",
      // 星期几
      weekday: "",
      activeIndex: 0,
      powerIndex: 0,
      // 柱形图1按钮
      columData: [
        {
          id: 1,
          title: "签约金额",
        },
        {
          id: 2,
          title: "签约数量",
        },
      ],
      // 柱形图2按钮
      powerData: [
        {
          id: 1,
          title: "全部",
        },
        {
          id: 2,
          title: "电话",
        },
        {
          id: 3,
          title: "微信",
        },
        {
          id: 4,
          title: "面对面",
        },
      ],
      value1: "",
      // 区域显隐
      areaIf: false,
      // 区域数组
      areaData: [
        { id: "1", title: "区域1" },
        { id: "2", title: "区域2" },
        { id: "3", title: "区域3" },
      ],
      // 选择月份
      mouthDate: [
        { id: "1", title: "近12个月", mouth: 12 },
        { id: "2", title: "近6个月", mouth: 6 },
        { id: "3", title: "近3个月", mouth: 3 },
      ],
      // 全部项目
      projectData: [
        { id: "1", title: "项目1" },
        { id: "2", title: "项目2" },
        { id: "3", title: "项目3" },
      ],
      //项目营销数据模拟
      yxdata: [
        "信华国际商务中心",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期七",
        "星期八",
        "星期九",
        "星期十",
      ],
    };
  },
  mounted() {
    this.drawLine();
    // this.drawColumnCharts();
    this.drawnowFollow();
    // this.drawPowerCharts();
    this.getNowDate();
    const nowMouth = new Date();
    this.chooseMouth = this.getPreviousMonths(nowMouth, "prev");
  },
  methods: {
    // 全部项目下拉
    allprojectClick() {
      this.projectIf = !this.projectIf;
    },
    // 子项目点击
    projectClick(res) {
      this.projectIf = !this.projectIf;
      this.$router.push({
        path: "/pFullPage",
        // 向子项目页面传值
        query: {
          id: res.id,
        },
      });
    },
    // 销售趋势接受返回值
    getDayTime(res) {},
    // 选择月份下拉
    selectMouth(res) {
      this.mouthText = res.title;
      this.mouthRange = res.mouth;
    },
    // 选择月份
    chooseMouths(res) {
      this.chooseMouth = res;
    },
    // 计算月份
    getPreviousMonths(res, type) {
      // 获取当前日期
      let currentDate = new Date(res);
      let nowYear = currentDate.getFullYear();
      // 获取当前月份
      let currentMonth = currentDate.getMonth() + 1; // 返回值为 0-11，需要加 1
      // 计算12个月前的年份和月份
      let year = currentDate.getFullYear();
      if (type == "next") {
        let month = currentMonth + this.mouthRange;
        if (month > 12) {
          year += 1;
          month -= 12;
        }
        return [nowYear + "-" + currentMonth, year + "-" + month];
      } else if (type == "prev") {
        let month = currentMonth - this.mouthRange;

        // 如果计算出的月份小于 1，需要向前推 1 年
        if (month < 1) {
          year -= 1;
          month += 12;
        }
        return [year + "-" + month, nowYear + "-" + currentMonth];
      }
    },

    // 上一个月
    prevMouth() {
      // 图表转换成canvas
      // 下载图片
      // html2canvas(document.getElementById("myChart")).then(function (canvas) {
      //   var img = canvas
      //     .toDataURL("image/png")
      //     .replace("image/png", "image/octet-stream");
      //   // 创建a标签，实现下载
      //   var creatIMg = document.createElement("a");
      //   creatIMg.download = "图表.png"; // 设置下载的文件名，
      //   creatIMg.href = img; // 下载url
      //   document.body.appendChild(creatIMg);
      //   creatIMg.click();
      //   creatIMg.remove(); // 下载之后把创建的元素删除
      // });
      this.chooseMouth = this.getPreviousMonths(this.chooseMouth[0], "prev");
    },
    // 下一个月
    nextMouth() {
      this.chooseMouth = this.getPreviousMonths(this.chooseMouth[1], "next");
    },
    //销售趋势下拉
    nearDateClick() {
      this.nearType = !this.nearType;
    },
    // 封装(传入时间、分类)
    preWeeks(day, type) {
      // 获取传入日期
      const days = new Date(day);
      const countDate = new Date(days);
      //根据type进行判断
      if (type == "prev") {
        // 计算前一天的日期
        countDate.setDate(countDate.getDate() - 1);
      } else if (type == "next") {
        countDate.setDate(countDate.getDate() + 1);
      }
      const year = countDate.getFullYear();
      // 获取月份
      const month = countDate.getMonth() + 1;
      // 获取日期
      const newday = countDate.getDate();
      // 获取星期几
      const weekday = countDate.getDay();
      // 定义星期几的文本表示
      const weekdayText = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      return [year + "-" + month + "-" + newday, weekdayText[weekday]];
    },
    // 上一周
    prevWeek() {
      const prevData = this.preWeeks(this.chooseDate, "prev");
      this.chooseDate = prevData[0];
      this.weekday = prevData[1];
      this.dateFormat = `MM / dd ${this.weekday}`;
    },
    // 下一周
    nextDay() {
      const nextData = this.preWeeks(this.chooseDate, "next");
      this.chooseDate = nextData[0];
      this.weekday = nextData[1];
      this.dateFormat = `MM / dd ${this.weekday}`;
    },
    // 获取当前日期
    getNowDate() {
      // 获取当前日期对象
      const currentDate = new Date();
      this.chooseDate = this.preWeeks(currentDate)[0];
      this.weekday = this.preWeeks(currentDate)[1];
      this.dateFormat = `MM / dd ${this.weekday}`;
    },
    // 选择日期
    chooseDates(res) {
      this.weekday = this.preWeeks(res)[1];
      this.dateFormat = `MM / dd ${this.weekday}`;
      this.chooseDate = res;
    },
    // 签约金额
    amountClick(item, index) {
      this.activeIndex = index;
    },
    // 销售强度
    powerClick(item, index) {
      this.powerIndex = index;
    },
    // 点击区域下拉
    areaClick() {
      this.areaIf = !this.areaIf;
    },

    // 区域点击详情
    areaDataClick(res) {},
    // 实时跟进数据
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        // 调整与边框距离
        grid: {
          x: 70,
          y: 35,
          x2: 50,
          y2: 95,
        },
        // title: {
        //   text: "某楼盘销售情况",
        //   subtext: "纯属虚构",
        // },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: false,
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     mark: { show: true },
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true },
        //   },
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#568BBE",
              },
            },

            data: [
              "00:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
              "24:00",
            ],
            axisLabel: {
              show: true,
              margin: 20,
              textStyle: {
                color: "#446BAC",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#305197",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              margin: 20,
              textStyle: {
                color: "#446BAC",
              },
            },
          },
        ],
        //折线颜色
        color: ["#A8EF39", "#DE47FF", "#389AFF"],
        series: [
          {
            name: "成交",
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              normal: { areaStyle: { type: "default", color: "#2C4E79" } },
            },
            data: [
              45, 74, 11, 32, 5, 73, 4, 59, 97, 8, 81, 23, 98, 42, 93, 53, 84,
              39, 36, 22, 27, 40, 94, 99, 31,
            ],
          },
          {
            name: "预购",
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              normal: { areaStyle: { type: "default", color: "#40458F" } },
            },
            data: [
              6, 20, 39, 24, 70, 81, 26, 13, 37, 40, 8, 2, 98, 69, 57, 11, 76,
              56, 41, 80, 15, 71, 45, 46, 85,
            ],
          },
          {
            name: "意向",
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              normal: { areaStyle: { type: "default", color: "#153E98" } },
            },
            data: [
              77, 40, 89, 34, 70, 81, 76, 73, 37, 49, 78, 92, 98, 69, 57, 91,
              76, 26, 21, 80, 55, 71, 35, 56, 82,
            ],
          },
        ],
      });
    },
    // 实时跟进数据
    drawnowFollow() {
      // 基于准备好的dom，初始化echarts实例
      let myChartNowfollow = this.$echarts.init(
        document.getElementById("myChartNowfollow")
      );
      // 绘制图表
      myChartNowfollow.setOption({
        // 调整与边框距离
        grid: {
          x: 70,
          y: 35,
          x2: 50,
          y2: 95,
        },
        // title: {
        //   text: "某楼盘销售情况",
        //   subtext: "纯属虚构",
        // },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: false,
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     mark: { show: true },
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true },
        //   },
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#568BBE",
              },
            },

            data: [
              "00:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
              "24:00",
            ],
            axisLabel: {
              show: true,
              margin: 20,
              textStyle: {
                color: "#446BAC",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#305197",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              margin: 20,
              textStyle: {
                color: "#446BAC",
              },
            },
          },
        ],
        //折线颜色
        color: ["#A8EF39", "#DE47FF", "#389AFF"],
        series: [
          {
            name: "成交",
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              normal: { areaStyle: { type: "default", color: "#2C4E79" } },
            },
            data: [
              45, 74, 11, 32, 5, 73, 4, 59, 97, 8, 81, 23, 98, 42, 93, 53, 84,
              39, 36, 22, 27, 40, 94, 99, 31,
            ],
          },
          {
            name: "预购",
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              normal: { areaStyle: { type: "default", color: "#40458F" } },
            },
            data: [
              6, 20, 39, 24, 70, 81, 26, 13, 37, 40, 8, 2, 98, 69, 57, 11, 76,
              56, 41, 80, 15, 71, 45, 46, 85,
            ],
          },
          {
            name: "意向",
            type: "line",
            smooth: true,
            symbol: "none",
            itemStyle: {
              normal: { areaStyle: { type: "default", color: "#153E98" } },
            },
            data: [
              77, 40, 89, 34, 70, 81, 76, 73, 37, 49, 78, 92, 98, 69, 57, 91,
              76, 26, 21, 80, 55, 71, 35, 56, 82,
            ],
          },
        ],
      });
    },
  },
};
</script>
  <style scoped>
.datacomponents {
  width: 100%;
  display: flex;
}
.leftDistance {
  margin-left: 25px;
}
.centerBack {
  width: 1200px;
  height: 72.8vh;
  margin-left: 2px;
  position: absolute;
  margin-top: 21px;
}
.leftColumTime {
  display: flex;
  align-items: center;
}
.coloumtitleText {
  display: flex;
  align-items: center;
  margin-top: 50px;
}
.leftColumTit {
  flex: 1;
  display: flex;
  align-items: center;
}
.leftColumText {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #d8d8d8;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #00e4ff 0%, #574bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.rightColumText {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #d8d8d8;
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #00e4ff 0%, #574bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.rightColumTit {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #d8d8d8;
  background: linear-gradient(180deg, #00e4ff 0%, #574bff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.leftColumTit {
  flex: 1;
}
.rightColumTit {
  flex: 1;
}
.nowFollowText {
  margin-left: 5px;
}
.nowFollwdata {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  height: 28px;
  line-height: 28px;
  background: #000b3e;
  color: #1db6ff;
  -webkit-text-fill-color: #1db6ff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  border-radius: 14px;
  padding: 0 13px 0 16px;
  margin-left: 20px;
}
.nowFollwCir {
  width: 9px;
  height: 9px;
  background: #20cb14;
  border-radius: 50%;
}
.blueBack {
  width: 1200px;
  height: 416px;
  position: absolute;
}
.car-item-five {
  background: linear-gradient(180deg, #aef536 0%, #1d5d57 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #e936fe;
}
.car-item-four {
  background: linear-gradient(180deg, #d340fd 0%, #650aba 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #e936fe;
}
.car-item-third {
  background: linear-gradient(180deg, #e1b950 0%, #907900 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #fdbf36;
}
.boderLine {
  width: 214px;
  height: 138px;
  position: absolute;
  top: 0px;
  left: 0px;
}
.backLine {
  position: absolute;
  width: 1200px;
  left: 50%;
  top: 6%;
  transform: translate(-50%, 0);
}
/deep/ .el-date-editor .el-range__icon {
  display: none;
}
/deep/ .el-date-editor .el-range-input {
  background: #000c3e;
}
/deep/ .el-date-editor .el-range__close-icon {
  display: none;
}
.nearMoutn {
}
.nearMouth-list {
  position: absolute;
  background: #0d1566;
  padding: 0 15px;
  margin-top: 6px;
  margin-right: 5px;
  border: 1px solid #084ab7;
  z-index: 10;

  -webkit-text-fill-color: #53abdf;
}
.nearMouth-list-item {
  margin: 10px 0;
  color: #53abdf;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.nearMouth-list-item:hover {
  -webkit-text-fill-color: #13c9ff;
}
.sellerdata-text .car-day-data {
  -webkit-text-fill-color: #1eb6fe;
}
.dateBtn {
  padding: 0 5px;
  font-size: 12px;
  width: 20px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  background: #000c3e;
  -webkit-text-fill-color: #1eb6fe;
}
.dateBtn:hover {
  color: #13c9ff !important;
}
/deep/.car-day-data .el-input__inner {
  background: #000c3e !important;
  text-align: center;
  height: 30px;
  width: 100px;
  color: #1db6ff;
  border: 0 !important;
  border-radius: 0 !important;
  -webkit-text-fill-color: #1eb6fe;
}
/deep/ .seller-data .el-input__inner {
  width: 220px !important;
}
/deep/ .coloumtitleText .el-input__inner {
  width: 185px !important;
}

/deep/.blockThird .el-range-editor.el-input__inner {
  justify-content: flex-end;
}
/deep/.car-day-data .el-input__prefix {
  display: none;
}
/deep/ .car-day-data .el-input--prefix .el-input__inner {
  padding-left: 0;
  height: 30px;
}
/deep/ .car-day-data .el-input--suffix .el-input__inner {
  padding-right: 0;
}

.sellerdata-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sellerdata-text {
  background: linear-gradient(to bottom, #13c9ff, #4576ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 22px;
  font-weight: 600;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.seller-data {
  margin: 50px 0 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-act {
  background: rgba(0, 93, 255, 0.16) !important;
  box-shadow: inset 0px 1px 80px 0px rgba(49, 184, 255, 0.5) !important;
}
.chartsBtn {
  display: flex;
  align-items: center;
  margin: 30px 0 0 20px;
  position: relative;
  /* background: red; */
}
.chartsbtn-item {
  margin-right: 20px;
  border-radius: 20px;
  padding: 5px 12px;
  color: #31b8ff;
  background: #0a1162;
  cursor: pointer;
}
.columnChart {
  display: flex;
}
.charts2 {
  flex: 1;
  width: 100%;
  height: 70vh;
  background: rgba(0, 93, 255, 0.16);
  box-shadow: inset 0px 1px 80px 0px rgba(0, 152, 255, 0.5);
  border-radius: 16px;
  border: 1px solid #1d7fff;
  display: flex;
  flex-direction: column;
  margin: 20px 10px 0 0;
}
.charts3 {
  flex: 1;
  width: 100%;
  height: 70vh;
  background: rgba(0, 93, 255, 0.16);
  box-shadow: inset 0px 1px 80px 0px rgba(0, 152, 255, 0.5);
  border-radius: 16px;
  border: 1px solid #1d7fff;
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 10px;
}
#myCharts2 {
  width: 100%;
  height: 100%;
}
#myCharts3 {
  width: 100%;
  height: 100%;
}
.sellitem-title {
  color: #13c9ff;
  padding: 5px;
  background: #0a1162;
  text-align: center;
  position: relative;
  top: -20px;
  width: 140px;
  margin: 0 auto;
  border-radius: 0 0 10px 10px;
}
.sell-data-block-item {
  flex: 1;
  padding: 18px;
  border-radius: 20px;
  background: #083395;
  background: #0f1961;
  box-shadow: inset 0 0 55px #145ecb;
  margin: 0 13px;
  position: relative;
  overflow: hidden;
  /* background-color: rgba(255, 255, 255, 0.5); */
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); */
}
.sell-item-one {
  margin-top: -15px;
  text-align: center;
  background: linear-gradient(to bottom, #13c9ff, #4576ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 34px;
  font-weight: 600;
}
.colorData {
  margin-left: 10px;
  font-size: 12px !important;
  color: greenyellow !important;
}
.rightselDdata {
  text-align: center;
  color: #13c9ff;
  margin-top: 5px !important;
  font-size: 10px !important;
}
.echartsBody {
  margin: 50px 0 0 0;
}
@media screen and (max-width: 480px) {
  .fullPage-body {
    width: 100% !important;
  }
  .blockFirst {
    display: none !important;
  }
  .blockThird {
    display: none !important;
  }
}
.devColortext1 {
  margin-left: 10px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a7ef38;
}
.echarts-list {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
}
.devColor1 {
  width: 22px;
  height: 5px;
  background: #1eca12;
  border-radius: 4px;
}
.echartsIndi {
  width: 326px;
  border-radius: 20px;
  height: 31px;
  z-index: 15;
  background: #0a1162;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  position: relative;
  bottom: 34px;
}
.echarts_1 {
  width: 100%;
  padding-bottom: 2vh;
  border-radius: 10px;

  height: 416px;
  /* border: 2px solid #fff; */
  background: "#0E2072";
  display: flex;
  flex-direction: column;
  align-items: center;
  /* box-shadow: inset 0 0 55px #145ecb; */
}
#myChart {
}
.navList {
  position: absolute;
  margin-top: 35px;
  background: #0d1566;
  padding: 0 15px;
  border: 1px solid #084ab7;
}
.nav-list-item {
  margin: 10px;
}
.nav-list-item:hover {
  color: #13c9ff;
}
.navListItem {
  display: flex;
  align-items: center;
}
.nav-item-first {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
/deep/.blockThird .el-input__inner {
  background: linear-gradient(
    270deg,
    rgba(13, 74, 168, 0.5) 0%,
    rgba(16, 20, 87, 0.5) 100%
  );
  border: none;
}
/deep/.blockThird .el-date-editor .el-range-separator {
  color: #61c6f6;
}
/deep/.blockThird .el-date-editor .el-range-input {
  color: #61c6f6;
  font-size: 18px;
  background-color: transparent;
  /* background: #0f2c7a; */
}
/deep/ .blockThird .el-date-editor .el-range-separator {
  /* width: lin; */
  width: 8%;
  line-height: 27px;
}
.blockThird {
  display: flex;
  justify-items: center;
  align-items: center;
  /* width: 230px !important; */
  width: 309px !important;
  height: 36px !important;
}
.car-item-span {
  font-size: 16px !important;
}
.car-item-two {
  font-size: 20px;
  font-weight: 600;
  color: #d42728 !important;
}
.car-item-one {
  background: linear-gradient(to bottom, #13c9ff, #4576ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 20px;
  font-weight: 600;
}
.item-text {
  font-size: 14px !important;
  margin-top: 20px;
  color: #79c0ed !important;
}
.car-data-block-item:nth-child(1) {
  margin-left: 0;
}
.car-data-block-item:last-child {
  margin-right: 0;
}
.car-data-block-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 17px;
  background: #fff;
  border-radius: 8px;
  margin: 0 16px;
}
.car-data-block-item span {
  font-size: 40px;
}

.car-data-block {
  display: flex;
  justify-content: space-between;
  margin: 20px 0 0 0;
  padding: 40px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.car-day-data {
  display: flex;
  align-items: center;
}
.nearBot {
  border-right: 2px solid #13c9ff;
  display: inline-block;
  padding: 0 15px 0 10px;
  font-size: 12px;
  line-height: 10px;
  height: 10px;
}
.sellerdata-day-data {
  margin-left: 20px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border-radius: 15px 0 0 15px;
  padding: 0 12px 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #000c3e;
  -webkit-text-fill-color: #1eb6fe;
  font-weight: 400;
}
.carList {
  display: flex;
  align-items: center;
}
.carData-text {
  font-size: 24px;
  font-weight: 600;
  display: flex;
  margin-right: 25px;
  /* justify-content: center; */
  align-items: center;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #010101;
}
.carData {
  /* display: flex; */
  /* align-items: center; */
  margin: 35px 0 0 0;
}
.nav-text {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #66cdff;
  /* margin: 25px 0 0 0; */
  /* border-top: #2c4a98 solid 1px; */
  border-bottom: #1889c7 solid 2px;
  border-radius: 50% / 100%;
}
.borderBox {
  width: 70%;
  margin: 0 auto;
  /* background: #083395; */
  height: 6vh;
  border-bottom: #2c4a98 solid 1px;
  border-radius: 1000% / 100%;
}
.nav-bottom-text {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-text-item {
  padding: 10px;
}
.fullPage {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  display: flex;
  justify-content: center;
  background: #eef4fb;
}
.fullPage-body {
  width: 1200px;
  padding: 0 0 50px 0;
}
.nav {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav-block {
  width: 230px;
  height: 50px;
  margin: 7vh 0 0 0;
  color: #63c9fa;
  text-align: center;
  font-weight: 600;
}
.blockFirst {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #010101;
  position: relative;
  height: 35px !important;
  line-height: 35px;
  font-weight: bold;
}
.blockSecond {
  /* width: 360px; */
  margin: 8.5vh 0 0 0;
  font-size: 36px;
  font-weight: bold;
  color: #010101;
  padding: 5px 100px 11px 100px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

.firstImg {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  margin-left: 22px;
}
</style>


// WEBPACK FOOTER //
// src/views/fullPage/index2.vue